// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8a251f0e","703":"616be8f0","787":"5c23a08d"}[chunkId] + ".chunk.js";
};